import { createDefaultDescPierre } from "../helpers/functions"

export const getPierre = state => {

    return createDefaultDescPierre(state.pierre.listePierre)
}
